//Built-in libraries

//Third party libraries

//Custom components
import { HookInput } from 'components/UI/HookForm/Form/Input';
import HookMaskedInput from 'components/UI/HookForm/Form/MaskedInput';
import Button from 'components/UI/Button';

//Services
import { useApplicationFormContext } from 'features/ApplicationForm/ApplicationFormProvider';

//STP Libraries

//Assets and Miscellaneous
import { useFormContext } from 'react-hook-form';

//Component Begin

export default function Information() {
  const { setCurrentStep, updateData } = useApplicationFormContext();
  const {
    trigger,
    formState: { isValid },
    getValues,
  } = useFormContext();

  const onSubmit = () => {
    trigger();
    const formData = getValues('step1');

    if (!isValid) {
      return;
    }

    updateData({
      step1: { ...formData },
    });
  };

  return (
    <div className='sm:rounded-r-md sm:overflow-hidden'>
      <div className='py-6 px-4 space-y-6 sm:p-6'>
        <h3 className='text-lg leading-6 font-medium text-green-500'>
          Information
        </h3>
        <div className='grid grid-cols-6 gap-4'>
          <HookInput
            customClassName='col-span-6'
            label='Name of Non-Profit'
            name='step1.name'
            type='text'
          />
          <HookInput
            customClassName='col-span-6'
            label='Street Address'
            name='step1.streetAddress'
            type='text'
          />
          <HookInput
            customClassName='col-span-6 sm:col-span-6 lg:col-span-2'
            label='Submitter Name'
            name='step1.submitter'
            type='text'
          />
          <HookInput
            customClassName='col-span-6 sm:col-span-6 lg:col-span-2'
            label='Submitter Title'
            name='step1.submitterTitle'
            type='text'
          />
          <HookMaskedInput
            customClassName='col-span-6 sm:col-span-6 lg:col-span-2'
            label='Phone Number'
            name='step1.phone'
            id='phone'
            maskedComponent='phone'
          />
          <HookMaskedInput
            customClassName='col-span-6 sm:col-span-6 lg:col-span-2'
            label='Fax'
            name='step1.fax'
            id='fax'
            maskedComponent='phone'
          />
          <HookInput
            customClassName='col-span-6 sm:col-span-3 lg:col-span-2'
            label='Email'
            name='step1.email'
            type='email'
            placeholder='myemail@example.com'
          />
        </div>

        <div className='flex gap-4 justify-end mt-5'>
          <Button
            label='Previous'
            btnStyle='neutral'
            type='button'
            onClick={() => setCurrentStep((prev) => prev - 1)}
          />
          <Button
            label='Next'
            btnStyle='primary'
            type='submit'
            onClick={onSubmit}
          />
        </div>
      </div>
    </div>
  );
}
